'use client';

import { useRouter } from 'next/navigation';

import type { AuthMode } from './types';

import { Logo } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { AUTH_MODE } from '@/lib/constants';

type HeaderProps = {
  mode: AuthMode;
};

export function Header({ mode }: HeaderProps) {
  const router = useRouter();

  return (
    <div className="h-16 border-b border-onboarding-border flex py-4 px-12 items-center justify-between">
      <Logo size={16} color="white" />
      <div className="flex items-center gap-4">
        <p className="text-sm text-muted-foreground">
          {mode === AUTH_MODE.SIGN_IN ? "Don't have an account?" : 'Already have an account?'}
        </p>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => router.push(mode === AUTH_MODE.SIGN_IN ? '/sign-up' : '/sign-in')}
        >
          {mode === AUTH_MODE.SIGN_IN ? 'Sign up' : 'Log in'}
        </Button>
      </div>
    </div>
  );
}
